'use client';

import { DataTestIdEnum } from '@medprev-web-app/datatestid';

import { PatientSelectionCreate } from './_components/patient-selection-create.component';
import { PatientSelectionList } from './_components/patient-selection-list.component';
import { PatientSelectionPhoneConfirmation } from './_components/patient-selection-phone-confirmation.component';
import { PatientSelectionModalKeys } from './_types/patient-selection-modal-keys.enum';

import { ProgressiveModal } from '@/components/ui/progressive-modal/progressive-modal.component';
import { PatientOption, ScheduleAgeRange } from '@/types/patient-selection.types';

export interface PatientSelectionModalProps {
  open: boolean;
  patients: PatientOption[];
  ageRange: ScheduleAgeRange;
  requiresPhoneConfirmation: boolean;
  pendingPatient: PatientOption | null;
  holderPhone: string;
  onClose: () => void;
  onSelectPatient: (patient: PatientOption) => void;
  onRequestPhoneConfirmation: (patient: PatientOption) => void;
}

export function PatientSelectionModal({
  open,
  patients,
  ageRange,
  requiresPhoneConfirmation,
  pendingPatient,
  holderPhone,
  onClose,
  onSelectPatient,
  onRequestPhoneConfirmation,
}: PatientSelectionModalProps) {
  return (
    <ProgressiveModal
      open={open}
      sheetSide="center-v2"
      hasHeader
      initialKey={PatientSelectionModalKeys.LIST}
      data-testid={DataTestIdEnum.PATIENT_SELECTION_MODAL}
      handleClose={onClose}
    >
      <PatientSelectionList
        key={PatientSelectionModalKeys.LIST}
        patients={patients}
        ageRange={ageRange}
        requiresPhoneConfirmation={requiresPhoneConfirmation}
        onSelectPatient={onSelectPatient}
        onRequestPhoneConfirmation={onRequestPhoneConfirmation}
      />
      <PatientSelectionCreate key={PatientSelectionModalKeys.CREATE} />
      <PatientSelectionPhoneConfirmation
        key={PatientSelectionModalKeys.PHONE_CONFIRMATION}
        patient={pendingPatient}
        currentPhone={holderPhone}
        onConfirmed={onSelectPatient}
      />
    </ProgressiveModal>
  );
}
